import Cookies from 'js-cookie';
import https from '@/lib/utils/https';
import { COOKIES } from '../constants';
import { GalleryCollection, InventoryCollection } from '@/types/collection';

type GetAllCollectionsReq = {
  params?: {
    limit?: number;
  };
};

type GetInventoryCollectionsRes = {
  collections: InventoryCollection[]
};

const getInventoryCollections = async () => {
  const token = Cookies.get(COOKIES.ACCESS_TOKEN);
  const resp = await https({ token }).get<GetInventoryCollectionsRes>('/v1/inventory/collections');

  return resp.data.collections;
};

type GetAllCollectionsResp = {
  collections: GalleryCollection[]
};

const getAllCollections = async (req?: GetAllCollectionsReq) => {
  let params: GetAllCollectionsReq['params'] = { limit: 100 };

  if (req?.params) {
    params = {
      ...req.params,
    };
  }

  const resp = await https().get<GetAllCollectionsResp>('/v1/collections', { params });

  return resp.data.collections;
};

const getCollection = async (id: string) => {
  const resp = await https().get<GalleryCollection>(`/v1/collections/${id}`);
  return resp.data;
};

const collectionsApi = {
  getAllCollections,
  getInventoryCollections,
  getCollection,
};

export default collectionsApi;
